import React, { useState } from 'react';
import styles from './ManagerWorkplaceItem.module.scss';
import ManagerWorkplaceModals from '../ManagerWorkplaceModals/ManagerWorkplaceModals';
import ManagerWorkplaceItemLabel from './ManagerWorkplaceItemLabel';
import ManagerWorkplaceItemActions from './ManagerWorkplaceItemActions';
import { joinClasses } from '../../../../../Utils/className.util';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';

interface WorkplaceManagementItemProps {
	item: WorkplacesTreeItem;
	onChange: () => void;
}

const ManagerWorkplaceItem = ({
	item,
	onChange,
}: WorkplaceManagementItemProps) => {
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const isFolder = item.type === 'folder';

	let className = joinClasses([styles.item, styles.workplace]);

	if (isFolder) {
		className = joinClasses([styles.item, styles.folder]);
	}

	return (
		<div className={styles.wrapper}>
			<div className={className}>
				<div className={styles.content}>
					{item.name && (
						<ManagerWorkplaceItemLabel
							itemName={item.name}
							hasFolderIcon={isFolder}
						/>
					)}
				</div>
				<div className={styles.control}>
					<ManagerWorkplaceItemActions
						item={item}
						openEditModal={setIsEditModalOpen}
						openDeleteModal={setIsDeleteModalOpen}
					/>
				</div>
				<ManagerWorkplaceModals
					isEditModalOpen={isEditModalOpen}
					setIsEditModalOpen={setIsEditModalOpen}
					isDeleteModalOpen={isDeleteModalOpen}
					setIsDeleteModalOpen={setIsDeleteModalOpen}
					item={item}
					onChange={onChange}
				/>
			</div>
			{(item.children?.length || 0) > 0 && (
				<div className={styles.childrenWrapper}>
					{item.children?.map(child => (
						<ManagerWorkplaceItem
							key={child.id}
							item={child}
							onChange={onChange}
						/>
					))}
				</div>
			)}
		</div>
	);
};

export default ManagerWorkplaceItem;
